export default function (state, { locale, fallback = null }) {
  const exists = state.availableLocales.includes(locale);

  if (!exists && !fallback) {
    return;
  }

  state.locale = exists ? locale : fallback;
}
